import React from 'react';
import LicenseApp from './components/LicenseApp';

/**
 * License page — rendered inside AdminLayout.
 * BaseAppComponent handles locale loading and initialization internally.
 */
const LicenseAppPage: React.FC = () => {
    return <LicenseApp />;
};

export default LicenseAppPage;
